// Client-side-only age gate for snippets/age-verification.liquid. Never touches server-rendered
// content - only ever toggles the [hidden] attribute on an overlay that's already fully present
// in the page source. Runs after DOMContentLoaded so it can't delay/block anything else.
(function () {
  function getCookie(name) {
    var escaped = name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1');
    var match = document.cookie.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  document.addEventListener('DOMContentLoaded', function () {
    var overlay = document.getElementById('age-verification-overlay');
    if (!overlay) return;

    if (getCookie('age_verified') === 'true') return;

    var confirmButton = overlay.querySelector('[data-age-confirm]');
    var denyButton = overlay.querySelector('[data-age-deny]');

    function lockScroll() {
      document.body.classList.add('age-verification-lock');
    }

    function unlockScroll() {
      document.body.classList.remove('age-verification-lock');
    }

    function show() {
      overlay.hidden = false;
      lockScroll();
      // Next frame, so the browser has painted the [hidden]->visible state first and the
      // opacity/transform transition (from CSS) actually has something to animate from.
      window.requestAnimationFrame(function () {
        overlay.classList.add('is-visible');
      });
    }

    function hide() {
      overlay.classList.remove('is-visible');
      unlockScroll();
      var finish = function () {
        overlay.hidden = true;
        overlay.removeEventListener('transitionend', finish);
      };
      overlay.addEventListener('transitionend', finish);
      // Fallback in case transitionend never fires (e.g. prefers-reduced-motion strips the
      // transition entirely).
      window.setTimeout(function () {
        overlay.hidden = true;
      }, 400);
    }

    if (confirmButton) {
      confirmButton.addEventListener('click', function () {
        setCookie('age_verified', 'true', 30);
        hide();
      });
    }

    if (denyButton) {
      denyButton.addEventListener('click', function () {
        window.location.href = denyButton.dataset.redirectUrl;
      });
    }

    show();
  });
})();
